<template>
<v-container fluid>
  <v-row>
    <v-col cols="12" class="py-0">
      <span class="title">Additional Interests</span>
    </v-col>
    <template v-if="data && data.length > 0">
      <v-col v-for="(ai, i) in data" :key="i" cols="12" md="6" class="py-1">
        <v-card color="blue5" @click="handleSelection(ai)">
          <v-card-title class="subtitle-1">
            {{ additionalInterestTypeNames[ai.type] }}
          </v-card-title>
          <v-card-subtitle class="text-truncate">
            {{ ai.name }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" class="py-0">
        No additional interests
      </v-col>
    </template>
  </v-row>

  <v-dialog v-model="interestSelected" scrollable>
    <v-card>
      <v-card-title :style="style" class="px-2">
        <span v-if="selectedInterest">
          {{ additionalInterestTypeNames[selectedInterest.type] }}
        </span>
        <v-spacer />
        <v-btn icon @click="interestSelected = false;selectedInterest=null;">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0 py-0">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="py-0">
              Add additional info here
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

</v-container>
</template>

<style scoped>
</style>

<script>
import { mapActions } from 'vuex';
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  name: 'Policies',
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      loading: true,
      selectedInterest: null,
      interestSelected: false,
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      },
      additionalInterestTypeNames: {
        0: 'UU',
        1: 'Certificate Holder',
        2: 'Lienholder',
        3: 'Mortgagee',
        4: 'Executor',
        5: 'Escrow Corporation',
        6: 'Mortgage Servicing Agency',
        7: 'Attorney in Fact',
        8: 'Finance Company',
        9: 'Loss Payee',
        10: 'Additional Interest',
        11: 'Loss payee, Additional Insured, and Additional Interest',
        12: 'Additional Interest Lessor',
        13: 'Municipality',
        14: 'Secured Loss Payee',
        15: 'Accounting Contact',
        16: 'Inspection Contact',
        17: 'Other',
        18: 'A1',
        19: 'OLT - Bicyle Liability',
        20: 'Members of Faculties and Teaching Staffs',
        21: 'A4',
        22: 'A5',
        23: 'A6',
        24: 'Additional Insured - State or Political Sub-divisions - Perm',
        25: 'Additional Insured - Volunteers (use VO instead)',
        26: 'Additional Insured - Volunteers (use VO instead)',
        27: 'Architects, Engineers, or Surveyors (use AG instead)',
        28: 'Employees other than executive officers (use EO instead)',
        29: 'Gasoline or Oil Dealers',
        30: 'Owners, managers, or Operators of Premises (use OM instead)',
        31: 'Owners or Contractors',
        32: 'States, Counties, Cities or other Governmental  Units - issued to owner or lease (use SC  instead)',
        33: 'States, Counties, Cities, or other Governmental  Units - issued to contractors (use SC instead)',
        34: 'Volunteer Workers (use VO instead)',
        35: 'All Other (use OT instead)',
        36: 'Architects, Engineers, or Surveyors (use AG instead)',
        37: 'Employees other than Executive Officers (use EO instead)',
        38: 'Volunteer Workers (use VO instead)',
        39: 'Concessionaires of premises on policies covering lessors',
        40: 'Lessors on policies covering concessionaires on their premises',
        41: 'Vendors - Limited Form',
        42: 'Vendors - Broad Form',
        43: 'Blanket Contract',
        44: 'Specific Contract',
        45: 'M1',
        46: 'Corporate Owner',
        47: 'Additional Bill Party',
        48: 'Additional Interest',
        49: 'Co-Owner/Occupant',
        50: 'Co-Owner/Non-Occupant',
        51: 'Title Holder',
        52: 'Claim Contact',
        53: 'Alternate Bill Party',
        54: 'Additional Insured and Mortgagee',
        55: 'Applicant\'s Employer',
        56: 'Co-Applicant\'s Employer',
        57: 'Franchisor',
        58: 'Manager/Lessor',
        59: 'Vendor',
        60: 'Controlling Interest',
        61: 'Co-Owner of Insured Premises',
        62: 'Land Lease Interests',
        63: 'Townhouse Association',
        64: 'Owner, Lessee, Contractor (Form A)',
        65: 'Owner, Lessee, Contractor (Form B)',
        66: 'Political Agency',
        67: 'State or Political Subdivision Permits Relating to Premises',
        68: 'Loss Payee and Additional Interest',
        69: 'Additional Insured Lessor',
        70: 'Additionnal Insured and Lienholder',
        71: 'Audit Contact',
        72: 'Employee as Lessor',
        73: 'Lenders Loss Payable',
        74: 'Additional Insured Lessor and Loss Payee',
        75: 'Contract Seller',
        76: 'Contract Purchaser',
        77: 'Fee Owner',
        78: 'Designated Person or Organization',
        79: 'Lessor of Leased Equipment',
        80: 'Contract of Sale',

        // We do not know the actual numbers for these records, but they are required.
        // We will need to add them as we know.
        100000: 'AG - Architects, Engineers or Surveyors',
        100001: 'AN - Additional Named Insured',
        100002: 'BN - Beneficial Owner',
        100003: 'EO - Employees Other than Executive Officers',
        100004: 'GR - Grantor',
        100005: 'MA - Mortgagee, Assignee or Receiver',
        100006: 'OM - Owners, Managers or Operators of Premises',
        100007: 'PL - Personal Liability',
        100008: 'SC - States, Counties, Cities or Other Governmental Units (not including Governmental Subdivisions)',
        100009: 'TE - Trustee',
        100010: 'TR - Trust',
        100011: 'VO - Additional Insured - Volunteers'
      }
    };
  },
  computed: {
  },
  methods: {
    ...mapActions(['setError']),
    handleSelection: function (ai) {
      analyticsService.sendEvent(this.$gtag, 'Button Click', 'Policy', 'Vehicle Additional Interest');
      this.selectedInterest = ai;
      this.interestSelected = true;
    }
  }
};
</script>
